import React from 'react';

import Color from '../utils/color';

// convert hex to rgb
export const hexToRgb = hex =>
	hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,(m, r, g, b) => '#' + r + r + g + g + b + b)
	.substring(1).match(/.{2}/g)
	.map(x => parseInt(x, 16));

export default function Style({ style=null }) {
	const CUSTOM_CSS_ID = 'custom-css';
	const PRIMARY_COLOR_CSS = 'primary-color-css';

	const create_css_element = React.useCallback((id, css) => {
		let css_element = document.createElement('style');
		css_element.setAttribute('type', 'text/css');
		css_element.setAttribute('id', id);
		css_element.innerText = css;
		return css_element;
	}, []);

	const remove_existing = React.useCallback((id) => {
		const exists = document.getElementById(id);
		if(exists) {
			exists.parentElement.removeChild(exists);
		}
	}, []);

	React.useEffect(() => {
		// Check if already added and remove it
		remove_existing(CUSTOM_CSS_ID);
		remove_existing(PRIMARY_COLOR_CSS);

		if(style) {
			const css = create_css_element(CUSTOM_CSS_ID, style);
			document.head.appendChild(css);
		}

		// Check if primary color
		let url_params = new URLSearchParams(window.location.search);
		if(!url_params.get('color_primary')) {
			return;
		}

		// Override primary color, url color does not begin with #
		const primary_color_url = hexToRgb(`#${url_params.get('color_primary')}`);
		const dark_primary_color = hexToRgb(Color.fromString(`#${url_params.get('color_primary')}`).darken(50).toString());
        const theme_css = `
			:root {
				--color-primary-rgba: ${primary_color_url} !important;
				--color-primary-dark-rgba: ${dark_primary_color} !important;
			}
		`;
		const theme = create_css_element(PRIMARY_COLOR_CSS, theme_css);
		document.head.appendChild(theme);
	}, [style, remove_existing, create_css_element]);

	return null;
}
